import { FC, ReactNode, useRef, useState } from 'react';
import classNames from 'classnames';

type TooltipType = {
  children: ReactNode;
  content: ReactNode;
};

const Tooltip: FC<TooltipType> = ({ children, ...props }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [mousePos, setMousePos] = useState<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });
  const ref = useRef<HTMLDivElement>(null);

  const styles = {
    // top: mousePos.y,
    top: ref.current?.getBoundingClientRect().top + 'px',
    // left: mousePos.x,
  };

  return (
    <div
      className="group flex items-center justify-center"
      ref={ref}
      onMouseEnter={(e) => setMousePos({ y: e.screenY, x: 0 })}
    >
      {children}
      <div
        style={styles}
        className="opacity-0 group-hover:opacity-100 transition-all duration-300 delay-0 group-hover:delay-300 pointer-events-none h-0 flex flex-col justify-end items-center -translate-y-1/2 z-10 group-hover:pointer-events-auto fixed"
      >
        <div className="!text-sm !font-normal leading-[1.3] relative flex items-center justify-center rounded-md p-5 bg-blue w-[400px] text-center text-white">
          {props.content}
        </div>
        <div className=" w-full flex flex-row justify-center items-center">
          <div
            className={classNames(
              'w-2 h-2 -translate-y-1/2 bg-blue rotate-45 ',
            )}
          />
        </div>
      </div>
      {/* <BaseTooltip
        arrow
        {...props}
        position="top"
        className="rounded-md p-3 bg-blue w-[250px] text-center text-white"
        wrapperClassName="z-10 "
        arrowClassName="w-2 h-2 rotate-45 z-[-1] bg-blue"
      >
        {children}
      </BaseTooltip> */}
    </div>
  );
};

export default Tooltip;
